import {Component, Input} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

import {CustomerStoriesModalComponent} from '@src/app/components_2.1/customer-stories-modal/customer-stories-modal.component';
import {SignUpModalComponent} from '@modules/user-guide/modals/sign-up-modal/sign-up-modal.component';
import {EditEventModalComponent} from '@src/app/components_2.1/edit-event-modal/edit-event-modal.component';
import {IUserGuide} from '../../shared/user-guide.model';
import {UserGuideService} from '../../shared/user-guide.service';

@Component({
  selector: 'app-user-guide-drawer',
  templateUrl: './user-guide-drawer.component.html',
  styleUrls: ['./user-guide-drawer.component.scss'],
})
export class UserGuideDrawerComponent {
  @Input() userGuide: IUserGuide[];

  constructor(
    public dialog: MatDialog,
    private userGuideService: UserGuideService
  ) {}

  closeUserGuide(): void {
    this.userGuideService.isDrawerOpen$.next(false);
  }

  openUserStoriesModal() {
    this.dialog.open(CustomerStoriesModalComponent);
  }

  finish() {
    if (!this.userGuideService.isFastSignup) {
      this.closeUserGuide();
      return;
    }

    this.dialog.open(SignUpModalComponent);
  }

  openEditEventModal() {
    this.dialog.open(EditEventModalComponent);
  }
}
